/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type WorkOSSSOIntentOptions = {
  /**
   * SSO bookmark slug to launch a specific app after authentication.
   */
  bookmarkSlug?: string | undefined;
  /**
   * SSO provider type to shortcut into a specific setup flow (e.g. OktaSAML, GoogleSAML).
   */
  providerType?: string | undefined;
};

/** @internal */
export type WorkOSSSOIntentOptions$Outbound = {
  bookmark_slug?: string | undefined;
  provider_type?: string | undefined;
};

/** @internal */
export const WorkOSSSOIntentOptions$outboundSchema: z.ZodMiniType<
  WorkOSSSOIntentOptions$Outbound,
  WorkOSSSOIntentOptions
> = z.pipe(
  z.object({
    bookmarkSlug: z.optional(z.string()),
    providerType: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      bookmarkSlug: "bookmark_slug",
      providerType: "provider_type",
    });
  }),
);

export function workOSSSOIntentOptionsToJSON(
  workOSSSOIntentOptions: WorkOSSSOIntentOptions,
): string {
  return JSON.stringify(
    WorkOSSSOIntentOptions$outboundSchema.parse(workOSSSOIntentOptions),
  );
}
